// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"124":"273e7982","198":"796a53f8","708":"7ebe8b14","803":"aa6ceb09","911":"6946dd7d"}[chunkId] + ".chunk.css";
};